import React, { useCallback, useState } from 'react';
import { Collapse } from 'antd';
import { useTranslation } from 'react-i18next';

import { SectionCard } from 'src/components';

import './faq.scss';
import { AmicoChatBot } from 'src/assets';

export const FAQ = () => {
  const { t } = useTranslation('faq');

  const [first, setFirst] = useState(['1']);
  const [second, setSecond] = useState([]);
  const [third, setThird] = useState([]);
  const [fourth, setFourth] = useState([]);

  const onChangeCollapse = useCallback(
    (value, setValue) => () => {
      if (value === '1') {
        setValue([]);
      } else {
        setValue(['1']);
      }
    },
    [],
  );

  return (
    <div className="faq">
      <SectionCard title={t('title')}>
        <div className="faq__collapse">
          <Collapse
            size="large"
            defaultActiveKey={first}
            className={first[0] === '1' ? 'active-collapse' : ''}
            onChange={onChangeCollapse(first[0], setFirst)}
            items={[
              {
                key: '1',
                label: t('faq:question:1:title'),
                children: <>{t('faq:question:1:description')}</>,
              },
            ]}
          />
        </div>
        <div className="faq__collapse">
          <Collapse
            size="large"
            className={second[0] === '1' ? 'active-collapse' : ''}
            onChange={onChangeCollapse(second[0], setSecond)}
            items={[
              {
                key: '1',
                label: t('faq:question:2:title'),
                children: <>{t('faq:question:2:description')}</>,
              },
            ]}
          />
        </div>
        <div className="faq__collapse">
          <Collapse
            size="large"
            className={third[0] === '1' ? 'active-collapse' : ''}
            onChange={onChangeCollapse(third[0], setThird)}
            items={[
              {
                key: '1',
                label: t('faq:question:3:title'),
                children: <>{t('faq:question:3:description')}</>,
              },
            ]}
          />
        </div>
        <div className="faq__collapse">
          <Collapse
            size="large"
            className={fourth[0] === '1' ? 'active-collapse' : ''}
            onChange={onChangeCollapse(fourth[0], setFourth)}
            items={[
              {
                key: '1',
                label: t('faq:question:4:title'),
                children: <>{t('faq:question:4:description')}</>,
              },
            ]}
          />
        </div>
      </SectionCard>

      <img src={AmicoChatBot} alt={AmicoChatBot} className="faq__image" />
    </div>
  );
};
